    export interface IChangeUsernameRequest {
        oldEmail: string;
        newEmail: string;
    }

    export class ChangeUsernameRequest implements IChangeUsernameRequest {
        oldEmail: string;
        newEmail: string;
    }